<template>
  <div>
    <Header />
    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i> Saha Giderleri</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item"><a href="#">anasayfa</a></li>
        </ul>
      </div>
      <div class="container">
        <div class="row ">
          <div class="col-lg-6">
            <div class="col-lg-12" style="background-color:#c1163b">
              <div style="font-size: 20px;font-weight: bolder;margin-bottom: 10px;">
                <p style="color: white;">{{ result.sahaName }}</p>
              </div>
            </div>
            <div class="col-lg-12" style="background-color:#c1163b">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p style="color: white;">
                  Makina =>{{ personelData.makina_code }}
                  {{ personelData.makina_name }}
                </p>
              </div>
            </div>
            <div class="col-lg-12" style="background-color:#c1163b">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p style="color: white;">Opr =>{{ personelData.opr_one }}</p>
              </div>
            </div>
            <div class="col-lg-12" style="background-color:#c1163b">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p style="color: white;">Yrd =>{{ personelData.yrd_one }}</p>
              </div>
            </div>
            <div class="col-lg-12" style="background-color:#c1163b">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p style="color: white;">
                  Tamamlanan iş Yüzdesi => %{{ result.isyuzdesi }}
                </p>
              </div>
            </div>
            <div v-for="(item, index) in datamakineler" :key="index">
              <div class="col-lg-12" style="background-color:rgb(239, 24, 24)">
                <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                  <p style="color: white;">
                    MAKİNE=> {{ datamakineler[index].makina_code }} {{ datamakineler[index].makina_name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="col-lg-12" style="background-color:rgb(239, 24, 24)">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p style="color: white;">
                  HARCANAN TOPLAM SARF => {{ deneme }}₺
                </p>
              </div>
            </div>
            <div class="col-lg-12" style="background-color:rgb(239, 24, 24)">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p style="color: white;">
                  DELİK BAŞI SARF MALİYETİ=> {{ delikMaliyet }}₺
                </p>
              </div>
            </div>
         
            <div class="col-lg-12" style="background-color:rgb(239, 24, 24)">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p style="color: white;">
                  DELİK BAŞI GİDER MALİYETİ => {{ detailData.maliyet }}₺
                </p>
              </div>
            </div>
            <div class="col-lg-12" style="background-color:rgb(239, 24, 24)">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p style="color: white;">
                  DELİK BAŞI TOPLAM MALİYET=> {{ toplamMaliyet }}₺
                </p>
              </div>
            </div>
            <!-- burada kaldım -->
            <div class="col-lg-12" style="background-color:rgb(239, 24, 24)">
              <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                <p style="color: white;">
                  DELİK BAŞI NET KAR KDV DAHİL=> {{ kalannetkar }}₺
                </p>
              </div>
            </div>

            <div v-for="(item, index) in makineler" :key="index">
              <span v-if="makineler[index].id > 0">
                <div class="col-lg-12" style="background-color:rgb(56 155 30)">
                  <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                    <p style="color: white;">
                      ADET=> {{ makineler[index].delgiadeti }} <span v-if="makineler[index].status == 0">DELGİ</span><span
                        v-if="makineler[index].status == 1">ÇAKIM</span>
                    </p>
                  </div>
                </div>
              </span>
              <span v-if="makineler[index] == false">
                <div class="col-lg-12" style="background-color:rgb(255 6 6)">
                  <div style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;">
                    <p style="color: white;">
                      ADET=> {{ makineler[index].delgiadeti }} <span v-if="makineler[index].status == 0">DELGİ</span><span
                        v-if="makineler[index].status == 1">ÇAKIM</span>
                    </p>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>

      </div>

      <div class="container">
        <div class="row ">
          <div class="col-lg-6">
            <div>

            </div>
          </div>
        </div>
      </div>
      <div>
        <span v-if="onaylar.fatura == 0">
          <button v-if="buttonid == 45 || buttonid == 41 || buttonid == 43 || buttonid == 1" @click="faturaonay()"
            class="btn btn-secondary" type="button">
            FATURA ONAYI
          </button>
        </span>
        <span v-if="onaylar.fatura == 1">
          <button v-if="buttonid == 45 || buttonid == 41 || buttonid == 43 || buttonid == 1" @click="tekrar()"
            class="btn btn-success" type="button">
            FATURA ONAYI
          </button>
        </span>
        <span v-if="onaylar.nakliye == 0">
          <button v-if="buttonid == 45 || buttonid == 41 || buttonid == 43 || buttonid == 1" @click="nakliyeonay()"
            class="btn btn-secondary" type="button">
            NAKLİYE ONAYI
          </button>
        </span>
        <span v-if="onaylar.nakliye == 1">
          <button v-if="buttonid == 45 || buttonid == 41 || buttonid == 43 || buttonid == 1" @click="tekrar()"
            class="btn btn-success" type="button">
            NAKLİYE ONAYI
          </button>
        </span>
        <span v-if="onaylar.tutanak == 0">
          <button v-if="buttonid == 45 || buttonid == 41 || buttonid == 43 || buttonid == 1" @click="tutanakonay()"
            class="btn btn-secondary" type="button">
            TUTANAK ONAYI
          </button>
        </span>
        <span v-if="onaylar.tutanak == 1">
          <button v-if="buttonid == 45 || buttonid == 41 || buttonid == 43 || buttonid == 1" @click="tekrar()"
            class="btn btn-success" type="button">
            TUTANAK ONAYI
          </button>
        </span>
        <span v-if="onaylar.koray == 0 && buttonid == 45">
          <button @click="sahaonay()" class="btn btn-secondary" type="button">
            SAHA ONAYI
          </button>
        </span>
        <span v-if="onaylar.koray == 1 && buttonid == 45">
          <button @click="sahaonaytekrar()" class="btn btn-success" type="button">
            SAHA ONAYI
          </button>
        </span>
        <span v-if="onaylar.emre == 0 && buttonid == 41">
          <button @click="sahaonay()" class="btn btn-secondary" type="button">
            SAHA ONAYI
          </button>
        </span>
        <span v-if="onaylar.emre == 1 && buttonid == 41">
          <button @click="sahaonaytekrar()" class="btn btn-success" type="button">
            SAHA ONAYI
          </button>
        </span>
        <span v-if="onaylar.ibrahim == 0 && buttonid == 43">
          <button @click="sahaonay()" class="btn btn-secondary" type="button">
            SAHA ONAYI
          </button>
        </span>
        <span v-if="onaylar.ibrahim == 1 && buttonid == 43">
          <button @click="sahaonaytekrar()" class="btn btn-success" type="button">
            SAHA ONAYI
          </button>
        </span>
        <span v-if="onaylar.yunus == 0 && buttonid == 50">
          <button @click="sahaonay()" class="btn btn-secondary" type="button">
            SAHA ONAYI
          </button>
        </span>
        <span v-if="onaylar.yunus == 1 && buttonid == 50">
          <button @click="sahaonaytekrar()" class="btn btn-success" type="button">
            SAHA ONAYI
          </button>
        </span>
        <span v-if="onaylar.hakan == 0 && buttonid == 51">
          <button @click="sahaonay()" class="btn btn-secondary" type="button">
            SAHA ONAYI
          </button>
        </span>
        <span v-if="onaylar.hakan == 1 && buttonid == 51">
          <button @click="sahaonaytekrar()" class="btn btn-success" type="button">
            SAHA ONAYI
          </button>
        </span>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="tile">
            <div class="tile-body">
              <table class="table table-hover table-bordered" id="sampleTable">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Ürün Adı</th>
                    <th>Adet</th>
                    <th>Personel Adı</th>
                    <th>Tutar</th>
                    <th>Açıklama</th>
                    <th>Makine Adı</th>
                    <th>Kullanıcı Adı</th>
                    <th>Kayıt Tarihi</th>
                    <th>Status</th>
                    <th>Oluşturma Tarihi</th>
                  </tr>
                </thead>
                <tbody ></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </main>
    <Sidebar />
  </div>

</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
export default {
  data() {
    return {
      result: [],
      status: 0,
      personelData: [],
      onaylar: [],
      detailData: [],
      stokData: [],
      makineler: [],
      datamakineler: [],
      isyuzdesi: "",
      noteId: "",
      buttonid: "",
      deneme: "",
      kalannetkar: "",
      toplamMaliyet: 0,
      delikMaliyet: 0,
      saha_idm: this.$route.query.idm,
      saha_id2: this.$route.query.idm,
    };
  },
  mounted: function () {

    window.scrollTo(0, 0);
    this.buttonid = localStorage.getItem("id");
    var token = localStorage.getItem("token");
    var id = localStorage.getItem("id");
    var admin_token = localStorage.getItem("admin_token");
    if (!token && !admin_token) {
      this.$router.push("/");
    }
    var datas = {
      saha_idm: this.saha_idm.substr(0,3),
      token: token,
      id: id,
    };
    var url2 = store.state.base_url + "AslanSahalar/getAllSahaMakinelerStatus.php?key=123";
    var datas = {
      id: localStorage.getItem("id"),
      token: localStorage.getItem("token"),
      saha_id: this.saha_idm.substr(0,3)
    };

    axios
      .post(url2, JSON.stringify(datas))
      .then((response) => {
        // this.makineler = response.dataMakine;
        this.datamakineler = response.data.dataMakine;
        this.makineler = response.data.dataMakineDelgi;
     
        //console.log(this.datamakineler);
      })
      .catch((err) => {
        console.log(err.response);
      });
    var url3 = store.state.base_url + "Onaylar/getSahaStatus.php?key=123";
    axios
      .post(url3, JSON.stringify(datas))
      .then((response) => {
        // this.makineler = response.dataMakine;
        this.onaylar = response.data;
      
        //console.log(this.datamakineler);
      })
      .catch((err) => {
        console.log(err.response);
      });

    let dataUrl =
      store.state.base_url + "AslanSahalar/getBySahaDetail.php?key=123";
    axios.post(dataUrl, JSON.stringify(datas)).then((response) => {
      this.result = response.data.data[0];
      this.personelData = response.data.temp;
      this.detailData = response.data.data[0].detail;
    });

    var results = this.result;
    let url = store.state.base_url + "AslanSahalar/getBySahaStok.php?key=123";
    var datas2 = {
      saha_id: this.saha_idm.substr(0,3),
      token: token,
      id: id,
    };
    axios
      .post(url, JSON.stringify(datas2))
      .then((response) => {
        datas2 = response.data.data;
        this.deneme = response.data.dataTemp.toplam_gider;
        this.delikMaliyet = parseInt(this.deneme / this.result.toplam_delgi);
        this.toplamMaliyet = parseInt(this.delikMaliyet) + parseInt(this.detailData.maliyet);
        this.kalannetkar = parseInt(this.result.fiyat_delgi) - parseInt(this.toplamMaliyet);
        console.log(this.kalannetkar)
        var table = $("#sampleTable").DataTable();
        $.each(datas2, function (index, value) {
          
          table.row
            .add([
              value["id"],
              value["product_id"],
              value["adet"],
              value["personel_id"],
              value["tutar"] + "₺",
              value["aciklama"],
              value["makine_id"],
              value["user_id"],
              value["date"],
              value["status"],
              value["reg_date"],
            ])
            .draw(false);
        });

        $("#sampleTable tbody").on("click", "tr", function () {
          var data = table.row(this).data();
          results.id = data[0];
          window.location.href = "#/stokguncelleme?id=" + results.id;
        });
      })
      .catch((err) => {
        //console.log(err.response);
      });
  },
  methods: {
    gomakinefilter: function () {
      window.location.href = "#/giderfiltrele?id=" + this.saha_idm;
    },
    pdfdownload() {
      window.open(`https://www.apidosya.aslanyazilimm.com/DosyaApi/index2.php?key=123&keyword=${this.saha_idm}`, "_blank");
    },
    faturaonay() {
      var dataStatus = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        saha_id: this.saha_idm.substr(0,3),
      };
      let dataUrl3 =
        store.state.base_url + "Onaylar/faturaonay.php?key=123";
      axios.post(dataUrl3, JSON.stringify(dataStatus)).then((response) => {
        this.$swal({
          text: "FATURA BAŞARIYLA ONAYLANDI",
          icon: "success",
          closeOnClickOutside: false,
        });
        setTimeout(function() {location.reload()},1250);
      });
    },
    nakliyeonay() {
      var dataStatus = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        saha_id: this.saha_idm.substr(0,3),
      };
      let dataUrl3 =
        store.state.base_url + "Onaylar/nakliyeonay.php?key=123";
      axios.post(dataUrl3, JSON.stringify(dataStatus)).then((response) => {
        this.$swal({
          text: "NAKLİYE BAŞARIYLA ONAYLANDI",
          icon: "success",
          closeOnClickOutside: false,
        });
      });
      setTimeout(function() {location.reload()},1250);
    },
    tekrar() {
      this.$swal({
        text: "ONAYLAMIŞTIN YA ZATEN :(",
        icon: "error",
        closeOnClickOutside: false,
      });
    },
    tutanakonay() {
      var dataStatus = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        saha_id: this.saha_idm.substr(0,3),
      };
      let dataUrl3 =
        store.state.base_url + "Onaylar/tutanakonay.php?key=123";
      axios.post(dataUrl3, JSON.stringify(dataStatus)).then((response) => {
        this.$swal({
          text: "TUTANAK BAŞARIYLA ONAYLANDI",
          icon: "success",
          closeOnClickOutside: false,
        });
        setTimeout(function() {location.reload()},1250);
      });
    },
    sahaonaytekrar() {
      var dataStatus = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        saha_id: this.saha_idm.substr(0,3),
      };
      let dataUrl3 =
        store.state.base_url + "Onaylar/sahaOnayTekrar.php?key=123";
      axios.post(dataUrl3, JSON.stringify(dataStatus)).then((response) => {
        if(response.data.emre == 0 && response.data.ibrahim == 0){
          var textswal =  "EMRE BEY VE İBRAHİM BEYİN ONAYI BEKLENİYOR"
        }else if(response.data.emre == 1 && response.data.ibrahim == 0){
          var textswal =  "İBRAHİM BEYİN ONAYI BEKLENİYOR"
        }else if(response.data.emre == 0 && response.data.ibrahim == 1){
          var textswal =  "EMRE BEYİN ONAYI BEKLENİYOR"
        }
        if(response.data.koray == 0 && response.data.emre == 0){
          var textswal =  "KORAY BEY VE EMRE BEYİN ONAYI BEKLENİYOR"
        }else if(response.data.koray == 1 && response.data.emre == 0){
          var textswal =  "EMRE BEYİN ONAYI BEKLENİYOR"
        }else if(response.data.koray == 0 && response.data.emre == 1){
          var textswal =  "KORAY BEYİN ONAYI BEKLENİYOR"
        }
        if(response.data.koray == 0 && response.data.ibrahim == 0){
          var textswal =  "KORAY BEY VE İBRAHİM BEYİN ONAYI BEKLENİYOR"
        }else if(response.data.koray == 1 && response.data.ibrahim == 0){
          var textswal =  "İBRAHİM BEYİN ONAYI BEKLENİYOR"
        }else if(response.data.koray == 0 && response.data.ibrahim == 1){
          var textswal =  "KORAY BEYİN ONAYI BEKLENİYOR"
        }else if(response.data.yunus == 0){
          var textswal =  "YUNUS BEYİN ONAYI BEKLENİYOR"
        }else if(response.data.hakan == 0){
          var textswal =  "HAKAN BEYİN ONAYI BEKLENİYOR"
        }
        this.$swal({
          text: textswal,
          icon: "error",
          closeOnClickOutside: false,
        });
      });
    },
    sahaonay() {
      if(this.onaylar.fatura == 1 && this.onaylar.nakliye == 1 && this.onaylar.tutanak == 1){

        var dataStatus = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        saha_id: this.saha_idm.substr(0,3),
      };
      let dataUrl3 =
        store.state.base_url + "Onaylar/sahaonay.php?key=123";
      axios.post(dataUrl3, JSON.stringify(dataStatus)).then((response) => {
        this.$swal({
          text: "SAHA BAŞARIYLA ONAYLANDI",
          icon: "success",
          closeOnClickOutside: false,
        });
        setTimeout(function() {location.reload()},1250);
      });
      }else{
        this.$swal({
          text: "TUTANAK - NAKLİYE - FATURA ONAYLANMADAN SAHA ONAYI VERİLEMEZ",
          icon: "error",
          closeOnClickOutside: false,
        });

      }

    },

  },
  components: {
    Header,
    Sidebar,
  },
};
</script>

<style>
#spanRegdate {
  font-size: 20px;
  text-align: right;
  display: block;
  margin-right: 10px;
  color: #c1163b;
}

#spanContent {
  font-size: 25px;
  margin-right: 10px;
  color: #c66a7e;
}

#pid1 {
  border-radius: 3px 22px;
  background-color: #5fe0d7;
  text-align: center;
  font-size: 25px;
}

#pid2 {
  border-radius: 3px 22px;
  background-color: #5fe0d7;
  text-align: center;
  font-size: 25px;
}
.deneme {
  background-color: #ea4d4d;
}
</style>



// WEBPACK FOOTER //
// src/components/SahaDetail.vue